import { actions, actionTypes, selectors } from 'data'
import { RejectedMessageType } from 'data/Socket/types'
import { TickerMessageType } from 'data/types'
import { call, put, select, takeEvery } from 'redux-saga/effects'
import webSocket from 'services/api/webSocket'
import { logger, sanitizeMessage } from 'utils'

import fetchApi from '../../utils/fetchApi'
import { getApiUrl } from '../../utils/urlBuilder'
import { StopTickerActionType } from './actions'

const messageManager = function* (action) {
  const message: TickerMessageType = action.payload
  if (message.event === webSocket.event.REJECTED) {
    logger.warn((message as RejectedMessageType).text)
    return
  }

  if (message.event === webSocket.event.UPDATED) {
    yield put(actions.ticker.setUpdate(message.symbol, sanitizeMessage(message)))
    return
  }

  if (message.event === webSocket.event.SNAPSHOT) {
    yield put(actions.ticker.setUpdate(message.symbol, sanitizeMessage(message)))
    return
  }

  if (message.event === webSocket.event.SUBSCRIBED) {
    yield put(actions.ticker.setSubscribed(message.symbol))
    return
  }

  if (message.event === webSocket.event.UNSUBSCRIBED) {
    yield put(actions.ticker.reset(message.symbol))
  }
}

const snapshot = function* () {
  const channel = webSocket.channel.TICKER

  const result = yield call(fetchApi, {
    auth: false,
    method: 'GET',
    url: getApiUrl('v3/exchange/tickers')
  })

  const { ok, response } = result

  if (ok) {
    for (let i = 0; i < response.length; i++) {
      yield put(
        actions.socket.received({ ...response[i], channel, event: webSocket.event.UPDATED })
      )
    }
  }
}

const start = function* () {
  const ws = yield select(selectors.socket.getConnection)
  if (!ws) return

  const channel = webSocket.channel.TICKER

  const currentInstrument = yield select(selectors.instrument.getCurrentInstrument)

  if (currentInstrument) {
    yield put(actions.socket.subscribe({ channel, symbol: currentInstrument.symbol }))
  }

  const previousInstrument = yield select(selectors.instrument.getPreviousInstrument)

  if (previousInstrument) {
    yield put(actions.socket.unsubscribe({ channel, symbol: previousInstrument.symbol }))
  }
}

const stop = function* (action: StopTickerActionType) {
  yield put(
    actions.socket.unsubscribe({
      channel: webSocket.channel.TICKER,
      symbol: action.payload.symbol
    })
  )
}

export default function* tickerMain() {
  yield takeEvery(actionTypes.instrument.SET_SYMBOL, start)
  yield takeEvery(actionTypes.ticker.SNAPSHOT, snapshot)
  yield takeEvery(actionTypes.ticker.STOP, stop)
  const channel = webSocket.channel.TICKER
  yield takeEvery(
    (action) => action.type === actionTypes.socket.RECEIVED && action.payload.channel === channel,
    messageManager
  )
}
